import "core-js/modules/es.function.name.js";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Inputext as Input } from './components/input-text';
import { Label } from './components/label';
import { HSpacer } from '../spacers/spacer-horizontal';
import { ContainerVertical } from '../layout/container-vertical';
export function InputText(props) {
  var value = props.format ? props.format(props.value) : props.value;

  var handleChange = function handleChange(event) {
    var rawValue = props.unformat ? props.unformat(event.target.value) : event.target.value;

    if (props.maxLength) {
      if (rawValue.length <= props.maxLength) {
        props.onChange(rawValue);
      }
    } else {
      props.onChange(rawValue);
    }
  };

  return /*#__PURE__*/_jsxs(ContainerVertical, {
    align: "flex-start",
    custom: true,
    input: true,
    children: [/*#__PURE__*/_jsx(Label, {
      htmlFor: props.name,
      children: props.label
    }), /*#__PURE__*/_jsx(HSpacer, {
      space: "5px"
    }), /*#__PURE__*/_jsx(Input, {
      name: props.name,
      id: props.id,
      placeholder: props.placeholder,
      value: value,
      onChange: handleChange,
      error: props.error
    })]
  });
}